import React, { useCallback, useEffect } from 'react';
import { Form } from 'antd';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import SimpleFormModal from '../../common/modals/SimpleFormModal';
import FormTextInput from '../../common/inputs/FormTextInput';
import { updateProjectScheduleOfValues } from '../state/projects.actions';

export default function ScheduleOfValuesNotesModal({
  selectedRow,
  onClose,
  visible,
  projectId,
  templateId,
}) {
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!selectedRow) {
      form.resetFields();
    } else {
      form.setFieldsValue(selectedRow);
    }
  }, [selectedRow]);

  const onSave = useCallback(async () => {
    const { notesColumn } = form.getFieldsValue() ?? {};

    const payload = {
      itemNumber: selectedRow.itemNumber,
      description: selectedRow.description,
      contractAmount: selectedRow.contractAmount,
      percentageComplete: selectedRow.percentageComplete,
      invoiceAmount: selectedRow.invoiceAmount,
      progressToDate: selectedRow.progressToDate,
      previousBillings: selectedRow.previousBillings,
      rowId: selectedRow.rowId,
      isChangeOrder: !!selectedRow.isChangeOrder,
      isSubContract: !!selectedRow.isSubContract,
      holdbackAmount: selectedRow.holdbackAmount,
      excludeHoldback: !!selectedRow.excludeHoldback,
      parentRowId: selectedRow.parentRowId,
      sectionId: selectedRow.sectionId,
      notesColumn,
      updatedField: 'notesColumn',
      number: selectedRow.number,
      unitType: selectedRow.unitType,
      estimatedQuantity: selectedRow.estimatedQuantity,
      previouslyBilledQuantity: selectedRow.previouslyBilledQuantity,
      billableQuantity: selectedRow.billableQuantity,
      billingCode: selectedRow.billingCode,
    };

    const result = await dispatch(updateProjectScheduleOfValues({
      projectId,
      templateId,
      payload,
    }));

    if (result) onClose();
  }, [projectId, templateId, onClose, selectedRow]);

  return (
    <SimpleFormModal
      title="Edit Notes"
      onClose={onClose}
      visible={visible}
      onSave={onSave}
    >
      <div style={{ width: '100%' }}>
        <Form form={form}>
          <FormTextInput
            name="notesColumn"
            isNotDisplay
            placeholder="Enter notes"
            textProps={{
              AutoComplete: 'off',
              textarea: true,
              rows: 6,
              style: { resize: 'none' },
            }}
          />
        </Form>
      </div>
    </SimpleFormModal>
  );
}

/* eslint-disable react/forbid-prop-types */
ScheduleOfValuesNotesModal.propTypes = {
  selectedRow: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  projectId: PropTypes.string,
  templateId: PropTypes.string,
};

ScheduleOfValuesNotesModal.defaultProps = {
  selectedRow: null,
  projectId: null,
  templateId: null,
};
